import { useNavigate, useParams } from "@tanstack/react-router"
import { Button } from "@aix/ui"
import { ArrowLeft } from "lucide-react"
import CoachTemplateEditor from "./components/CoachTemplateEditor"

export default function CoachTemplateDetailScreen() {
  const navigate = useNavigate()
  const params = useParams({ strict: false }) as { templateId: string }

  const isNew = params.templateId === "new"
  const templateId = isNew ? undefined : params.templateId

  const handleSave = (template: any) => {
    // Navigate back to templates list
    navigate({
      to: "/coach-os",
      // @ts-ignore
      search: (prev) => ({ ...prev, tab: "templates" }),
    })
  }

  return (
    <div className="h-full flex flex-col bg-background">
      {/* Header */}
      <div className="border-b-2 border-border bg-secondary p-4">
        <div className="flex items-center gap-3">
          <Button
            onClick={() =>
              navigate({
                to: "/coach-os",
                // @ts-ignore
                search: (prev) => ({ ...prev, tab: "templates" }),
              })
            }
            variant="outline"
            size="sm"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Templates
          </Button>
          <h1 className="text-xl font-bold text-primary">{isNew ? "New Coach Template" : "Edit Coach Template"}</h1>
        </div>
      </div>

      {/* Editor */}
      <div className="flex-1 overflow-hidden">
        <CoachTemplateEditor templateId={templateId} onSave={handleSave} />
      </div>
    </div>
  )
}
